export default __webpack_public_path__ + "static/media/loading_vid.dd420b95.mp4";